const LOGIN_PATHS: string[] = ["", "/login", "/login/signed-out"];

const normalize = (path: string): string =>
  path.endsWith("/") && path.length > 1 ? path.slice(0, -1) : path;

const Storage = {
  saveRedirectPath: (redirectPath: string): void => {
    const rawPath = redirectPath ?? window.location.pathname;
    const path = normalize(rawPath);
    const isLoginPath = LOGIN_PATHS.includes(path);
    sessionStorage.setItem("redirectPath", isLoginPath ? "/" : path);
  },
  getRedirectPath: (): string | null => sessionStorage.getItem("redirectPath"),
  removeRedirectPath: (): void => sessionStorage.removeItem("redirectPath"),
  saveUsingCognitoCookies: (): void => {
    localStorage.setItem("loginAppRedirect", "true");
  },
  getUsingCognitoCookies: (): boolean => localStorage.getItem("loginAppRedirect") === "true",
  removeUsingCognitoCookies: (): void => {
    localStorage.removeItem("loginAppRedirect");
  },
};

export const saveUsingCognitoCookies = (): void => {
  Storage.saveUsingCognitoCookies();
};

export const getUsingCognitoCookies = (): boolean => {
  return Storage.getUsingCognitoCookies();
};

export const removeUsingCognitoCookies = (): void => {
  Storage.removeUsingCognitoCookies();
};

export const savePathForRedirect = (redirectPath?: string): void => {
  if (redirectPath) {
    Storage.saveRedirectPath(redirectPath);
  }
};

export const getAndRemovePathForRedirect = (): string | null => {
  const path = Storage.getRedirectPath();
  Storage.removeRedirectPath();
  return path;
};
